if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends HTMLElement {
      constructor() {
        super();
        
        // Get the overlay and image container
        this.overlay = this.querySelector('.product-media-modal__overlay');
        this.imageContainer = this.querySelector('.product-media-modal__image-container');
        this.modalImage = this.querySelector('.product-media-modal__image');
        this.preloadedImages = new Map();
        
        // Close modal when clicking outside the image (on overlay)
        if (this.overlay) {
          this.overlay.addEventListener('click', (event) => {
            if (event.target === this.overlay) {
              this.hide();
            }
          });
        }
        
        // Close on ESC key
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
        
        // Setup hover preloading for all modal openers
        this.setupPreloading();
      }
      
      setupPreloading() {
        // Find all modal openers and add hover listeners for preloading
        const modalOpeners = document.querySelectorAll('modal-opener');
        modalOpeners.forEach(opener => {
          opener.addEventListener('mouseenter', () => {
            const imageElement = opener.querySelector('img');
            if (imageElement) {
              const srcset = imageElement.getAttribute('srcset');
              if (srcset) {
                const srcsetArray = srcset.split(',').map(s => s.trim());
                const lastSrc = srcsetArray[srcsetArray.length - 1];
                const imageSrc = lastSrc.split(' ')[0];
                
                // Preload if not already preloaded
                if (imageSrc && !this.preloadedImages.has(imageSrc)) {
                  const preloadImg = new Image();
                  preloadImg.src = imageSrc;
                  this.preloadedImages.set(imageSrc, preloadImg);
                }
              }
            }
          });
        });
      }

      show(opener) {
        // Only show on desktop (≥ 1024px)
        if (window.innerWidth < 1024) return;
        
        this.openedBy = opener;
        
        // Save current scroll position
        this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        
        // Get the image source from the modal-opener container (parent of the button)
        const modalOpener = opener.closest('modal-opener');
        const imageElement = modalOpener ? modalOpener.querySelector('img') : null;
        
        if (!imageElement) return;
        
        // Get the highest quality image from srcset or fallback to src
        let imageSrc = imageElement.getAttribute('src') || '';
        const srcset = imageElement.getAttribute('srcset');
        
        if (srcset) {
          // Extract the largest image URL from srcset
          const srcsetArray = srcset.split(',').map(s => s.trim());
          const lastSrc = srcsetArray[srcsetArray.length - 1];
          imageSrc = lastSrc.split(' ')[0] || imageSrc;
        }
        
        const imageAlt = imageElement.getAttribute('alt') || '';
        
        // Check if high-res image is already preloaded
        const isPreloaded = this.preloadedImages.has(imageSrc);
        
        // Use preloaded image immediately if available, otherwise use thumbnail
        this.modalImage.setAttribute('src', isPreloaded ? imageSrc : imageElement.src);
        this.modalImage.setAttribute('alt', imageAlt);
        
        // Show the modal and keep scrollbar visible
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.overflowY = 'scroll';
        this.setAttribute('open', '');
        this.classList.add('modal-fade-in');
        
        // Load high-res image if not preloaded
        if (!isPreloaded && imageSrc && imageSrc !== imageElement.src) {
          const highResImage = new Image();
          highResImage.onload = () => {
            this.modalImage.setAttribute('src', imageSrc);
            this.preloadedImages.set(imageSrc, highResImage);
          };
          highResImage.src = imageSrc;
        }
      }

      hide() {
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflowY = '';
        
        // Restore scroll position
        if (this.scrollPosition !== undefined) {
          window.scrollTo(0, this.scrollPosition);
        }
        
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        this.classList.remove('modal-fade-in');
        
        // Clear the image after animation (reduced from 300ms to 150ms)
        setTimeout(() => {
          this.modalImage.setAttribute('src', '');
          this.modalImage.setAttribute('alt', '');
        }, 150);
      }
    }
  );
}
